//// sidebar
(function($, window, undefined) {

  var defaults = {}

  function wbskFFUESsearch(element,settings) {
    this.settings = settings
    this.$form = $(element)
    this.hasResults = false
    this.init()
  }

  wbskFFUESsearch.prototype = {
    init: function() {      
      var _this = this
      this.lstoken = 'ffuesRecentSearches3b'
      const recentSearches = window.localStorage.getItem(this.lstoken)
      _this.recentResults = recentSearches ? JSON.parse(recentSearches) : []
      
      
      _this.$resultsWrapper = _this.$form.find('.wbskFFues__results-wrapper')
      _this.$resultsItems = _this.$form.find('.wbskFFues__resultsItems')
      _this.$resultsHistoryItems = _this.$form.find('.wbskFFues__resultsHistoryItems')
      _this.$input = _this.$form.find('input[name="terms"]')
      
      
      _this.$form.click(function(e){
        e.stopPropagation()
      })
      
      _this.$input.on('keyup',function(){
        _this.onTermsUpdate(_this,$(this).val())
      }.debounce(500))
      
      _this.$input.on('focus',function(){
        _this.show()
      })
      
      _this.$input.on('focusout ',function(){
        
      })
      
      $(document).on('click','.wbskFFues--body-active',function(e){
        _this.hide()
      })
      
     
      _this.updateRecentResults()
      
    },
    
    show:function(){
      $('body').addClass('wbskFFues--body-active')
      this.$form.addClass('wbskFFues--active')
      if(this.settings.PubSub_id){
       PubSub.publish(this.settings.PubSub_id,{type:'show'}) 
      }
    },
    
    hide:function(){
      $('body').removeClass('wbskFFues--body-active')
      this.$form.removeClass('wbskFFues--active')
      if(this.settings.PubSub_id){
        PubSub.publish(this.settings.PubSub_id,{type:'hide'}) 
      }
    },
    
    bindLinks:function(){
      const _this = this
      this.$form.find('a').click(function(e){
        if (!e.target.classList.contains('skip-to-content-link')) {
          e.preventDefault();
          const link = $(this).attr('href')
          const data = JSON.parse($(this).attr('data-org'))
          const recentResultsIds = _this.recentResults.map(item => item.organization_id)
          if(recentResultsIds.indexOf(data.organization_id) < 0 ){
            _this.recentResults.push(data)
            window.localStorage.setItem(_this.lstoken , JSON.stringify(_this.recentResults))
          }
          window.location.href = link
        }
      })
    },
    
    getSearchUrl:function(terms){
      return `https://schooladmin.myclothing.com/api/v1.0/organization/lookupregistered?query=${terms}&limit=100`
    },
    
    getItemLines:function(arrayOfItems,isHistory){
      return arrayOfItems.map(item => {
        const address = Object.values(item.address).filter(line => line && line.length > 0)
        address.shift()
        address.join(',')

        if(!item.subunits || !item.subunits.length){
          return `<a href="/collections/${item.shopify_collection_handle}/${window.location.search}" class="wbskFFues__result-item" data-org='${JSON.stringify(item).replace(/'/g, '')}'>
                    <img class="wbskFFues__result-item-img lazyload" alt="${ item.shopify_collection_name } logo" width="100" height="100" data-src="${item.emblem.png}" style="background:rgb(${item.emblem.background});padding:3px;">
                    <div class="wbskFFues__result-item-content">
                      <span class="d-block row--xxs t-s f-w500">${isHistory && item.shopify_collection_name ? item.shopify_collection_name : item.name}</span>
                      <span class="t-xs t-grey f-w400">${address}</span>
                    </div>
                  </a>`
        }else{
          const parent = `<span class="wbskFFues__result-item" data-org='${JSON.stringify(item)}'>
                    <img class="wbskFFues__result-item-img lazyload" width="100" height="100" data-src="${item.emblem.png}" style="background:rgb(${item.emblem.background});padding:3px;">
                    <div class="wbskFFues__result-item-content">
                      <span class="d-block row--xxs t-s f-w500">${item.name}</span>
                      <span class="t-xs t-grey f-w400">${address}</span>
                    </div>
                  </span>`
          const subunits = item.subunits.map( subunit => {
            //subunit.sub_parent_title = `${item.name} (${subunit.name})`
            return `<a href="/collections/${subunit.shopify_collection_handle}" class="wbskFFues__result-item wbskFFues__result-item--child" data-org='${JSON.stringify(subunit).replace(/'/g, '')}'>
                    <img class="wbskFFues__result-item-img lazyload" width="100" height="100" is-sub="true" data-src="${subunit.emblem.png}" style="background:rgb(${subunit.emblem.background});padding:3px;">
                    <div class="wbskFFues__result-item-content">
					  <span class="d-block t-s f-w500">${subunit.name}</span>
                    </div>
                  </a>`
          })
          return parent + subunits.join('')
        }
      })
    },
    
    updateResults:function(organizations){
      let resultsHtml = this.getItemLines(organizations)
      this.$resultsItems.empty().html(resultsHtml.join(''))
      this.bindLinks()
    },
    
    updateRecentResults:function(){
      const results = JSON.parse(JSON.stringify(this.recentResults))
      results.length = results.length > 10 ? 10 : results.length
      this.$form.attr('data-has_history',results.length ? true : false)
      let resultsHtml = this.getItemLines(results.reverse(),true)
      this.$resultsHistoryItems.empty().html(resultsHtml.join(''))
      this.bindLinks()
    },
    
    onTermsUpdate:  function(_this,terms){
       _this.$form.attr('data-has_terms',terms.length > 0)
      if(terms.length > 2){
        const url = _this.getSearchUrl(terms)
        fetch(url).then( response =>  response.json() ).then( results => {
          _this.hasResults = results.count ? true : false
          _this.$form.attr('data-has_results',_this.hasResults)
          if(_this.hasResults){
            _this.updateResults(results.organizations)
          }
        });
       
      }else{
        _this.$form.attr('data-has_results',false)
        _this.updateRecentResults()
      }
    }
    
 
  }
  
  
  $.fn.wbskFFUESsearch = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskFFUESsearch', new wbskFFUESsearch(this, settings))
    })
  }

}(jQuery, window));
